import pipe from 'ramda/src/pipe'
import map from 'ramda/src/map'
import path from 'ramda/src/path'
import prop from 'ramda/src/prop'
import split from 'ramda/src/split'
import when from 'ramda/src/when'
import is from 'ramda/src/is'
import pathEq from 'ramda/src/pathEq'
import reject from 'ramda/src/reject'
import isNil from 'ramda/src/isNil'
import uniq from 'ramda/src/uniq'
import dropEventHof from 'root/src/client/logic/dropEvent/util/dropEventHof'
import { camelCaseSpace } from 'root/src/shared/util/stringCase'
import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'

export default pipe(
	dropEventHof('dares'),
	when(
		is(Array),
		pipe(
			map(
				dare => (pathEq(['product', 'type'], brandProductTypesEnum.dropKey, dare)
					? pipe(
						path(['product', 'id']),
						split('|'),
						prop(2),
						camelCaseSpace,
					)(dare)
					: null),
			),
			reject(isNil),
			uniq,
		),
	),
)
